import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ENDUSER_OFFER_OID } from '../../shared/injectionTokens';

import { BobHttpClient } from './BobHttpClient';
import { EndUserLegalDocumentGateway } from './EndUserLegalDocumentGateway';

const LINK_REQUEST_ENDPOINT = '/link-request-api/public/v1';
const LEGAL_DOCUMENT_ENDPOINT = '/legaldocs-api/public/v1';

interface GetTermsOfServiceLinkRequestResponse {
    documentLink: string;
}

@Injectable()
export class HttpLegalDocumentGateway implements EndUserLegalDocumentGateway {
    constructor(
        protected http: BobHttpClient,
        @Inject(ENDUSER_OFFER_OID) private offerOID: string,
    ) {}

    getTermsOfServiceDocumentLink(token: string, lang?: string): Observable<string> {
        const params = lang ? { lang } : {};

        return this.http
            .get<GetTermsOfServiceLinkRequestResponse>(
                `${LINK_REQUEST_ENDPOINT}/requests/${token}/terms-of-service`,
                params,
            )
            .pipe(map((response) => response.documentLink));
    }

    approveLegalDocument(token: string): Observable<void> {
        const decodedToken = JSON.parse(atob(token));
        const params = { offerOID: this.offerOID, countryCode: decodedToken.countryCode };

        return this.http.post<void>(
            `${LEGAL_DOCUMENT_ENDPOINT}/userapproval/documents/approve`,
            {
                signatureType: 'simple',
            },
            params,
        );
    }
}
